
import React from 'react';
import { Label } from '@/components/ui/label';
import { Switch } from '@/components/ui/switch';

interface CompactBilingualSwitchProps {
  value: boolean;
  onChange: (value: boolean) => void;
  disabled?: boolean;
}

export default function CompactBilingualSwitch({
  value,
  onChange,
  disabled = false
}: CompactBilingualSwitchProps) {
  return (
    <div className="space-y-1">
      <Label className="text-black dark:text-white font-medium text-xs">
        Bilingual prayer (English + 中文)
      </Label>
      <div className="flex items-center justify-start">
        <Switch
          checked={value}
          onCheckedChange={onChange}
          disabled={disabled}
        />
        <span className="ml-2 text-xs text-black/70 dark:text-white/70">
          {value ? 'On' : 'Off'}
        </span>
      </div>
    </div>
  );
}
